import React from "react";
import "./about.css";
import Layout from "./../Layout/Layout";
import about1 from "../../assets/aboutpage3.png";
import mainabout1 from "../../assets/newImg/abt3.jpg";
import mainabout2 from "../../assets/newImg/abt2.jpg";
import mainabout3 from "../../assets/newImg/abt1.jpg";
import mainabout4 from "../../assets/mainabout2.png";
import logo1 from "../../assets/logo1.jpeg";
const About = () => {
  return (
    <Layout>
      <div className="container mb-xxl-5 mb-xl-5 mb-lg-5 mb-md-3  mb-3">
        <div className="row">
          <div className="col-12">
            <section class="about-us">
              <h2 className="text-center abth1 my-xxl-4 my-lg-3 my-md-2 my-sm-1 my-1 m">
                About Us
              </h2>
            </section>
          </div>
        </div>
      </div>

      <div className="container  mb-xxl-5 mb-xl-5 mb-lg-5 mb-md-3  mb-3">
        <div className="row aboutBg1 mb-xxl-4 mb-xl-3 mb-lg-3 mb-md-3  mb-2 ">
          <div className="col-lg-1">
            <img src={logo1} alt="Logo" className="headLogo " />
          </div>
          <div className="col-lg-11">
            <p className="abtP2">
              &nbsp; At Mestry Circle, we believe building a home should feel
              like a celebration, not a struggle. That’s why we’ve created a
              trusted digital adda where every house owner can find the right
              people directly from their phone. From civil engineers to
              painters, from mestries to electricians, from cement shops to tile
              stores—we bring together every vendor you need in one place.
            </p>
          </div>
          <div className="col-12">
            {" "}
            <p className="abtP2 abtP10">
              Whether you're laying the first brick or choosing the final coat
              of paint, Mestry Circle connects you with skilled, verified
              professionals who care about your home as much as you do. No more
              running around, no more guesswork—just peace of mind, savings, and
              support at every step.
            </p>
            <p className="abtP2 ">
              Because for us, this isn’t just construction—it’s about helping
              every family, in every corner of India, build their dream with
              confidence, clarity, and joy.
            </p>
          </div>
        </div>
      </div>
      <div className="container  mb-xxl-5 mb-xl-5 mb-lg-5 mb-md-3  mb-3">
        <div className="row aboutBg2 mb-xxl-4 mb-xl-3 mb-lg-3 mb-md-3  mb-2 d-flex justify-content-around">
          <div className="col-md-6">
            <h3 className="abth2 ">Our mission</h3>
            <br />
            <p className="abtP  d-flex justify-content-center align-items-center ">
              We believe every family deserves a trusted path to building their
              dream home. That’s why we’re committed to connecting people with
              reliable, verified contractors—starting from India’s metro cities
              and reaching every town, every street, and every hopeful heart.
              Whether you’re laying your first brick or planning your final
              finish, we’re here to guide you with honest support, local
              expertise, and a promise of trust. Homebuilding should feel
              joyful, not overwhelming—and with the right people by your side,
              it truly can be.
            </p>
          </div>
          <div className="col-md-5 mobileDflex3 ">
            <img src={mainabout2} alt="" className="mainAboutImg  " />
          </div>
        </div>
      </div>
      <div className="container  mb-xxl-5 mb-xl-5 mb-lg-5 mb-md-3  mb-3">
        <div className="row aboutBg3 mb-xxl-4 mb-xl-3 mb-lg-3 mb-md-3  mb-2 d-flex justify-content-around">
          <div className="col-md-6">
            <h3 className="abth3 ">How Mestry circle works</h3>
            <br />
            <p className="abtP  d-flex justify-content-center align-items-center ">
              In India, finding a plumber or electrician is easy—but building a
              home is much more than that. Families often struggle to find the
              right masons, contractors, and material suppliers because most
              platforms offer scattered services that dilute the real need.
              Mestry Circle was born to solve this. We focus purely on home
              construction—no distractions, no confusion. Whether you need a
              trusted vendor for foundation work or the nearest cement shop, we
              give you exactly what you’re looking for on one simple, local
              platform. It’s clarity, comfort, and connection—built for your
              dream home.
            </p>
          </div>
          <div className="col-md-5 mobileDflex3">
            <img src={mainabout3} alt="" className="mainAboutImg" />
          </div>
        </div>
      </div>
      <div className="container  mb-xxl-5 mb-xl-5 mb-lg-5 mb-md-3  mb-3">
        <div className="row aboutBg4 mb-xxl-4 mb-xl-3 mb-lg-3 mb-md-3  mb-2 d-flex justify-content-around">
          <div className="col-md-6">
            <h3 className="abth4 ">Our leadership team</h3>
            <br />
            <p className="abtP4  d-flex justify-content-center align-items-center ">
              Behind Mestry Circle is a team of passionate professionals who
              understand the true essence of home construction. With decades of
              combined experience across the construction, technology, and
              service industries, our leaders bring vision, precision, and a
              deep sense of responsibility to everything we do. They don’t just
              guide a company—they guide a movement toward smarter, more
              transparent, and more reliable homebuilding across India. At
              Mestry Circle, leadership means listening, innovating, and shaping
              every home journey with integrity and purpose.
            </p>
          </div>
          <div className="col-md-5 mobileDflex3">
            <img src={mainabout1} alt="" className="mainAboutImg" />
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default About;
